import { ToDateTimeText, ToDateFullMonthText } from "../../../utils/date";
import Box from "@material-ui/core/Box";
import Alarm from '@material-ui/icons/Alarm';
import Link from '@material-ui/core/Link';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

export const getColumns = (ViewHistory) => {
  const columns = [
    {
      dataField: "JOB_ID",
      text: "ID",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "JOB_NAME",
      text: "Job Name",
      sort: true,
      headerAlign: 'center',
      formatter: (cell, row) => {
        return (
          <Link
            component="button"
            variant="body2"
            onClick={() => {
              ViewHistory(row.JOB_GUID);
            }}
          >
            {row.JOB_NAME}
          </Link>
        )

      }
    },
    {
      dataField: "CREATE_BY",
      text: "User",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "SCHEDULE_TYPE",
      text: "Schedule Type",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "SCHEDULE_DATE",
      text: "Schedule Date",
      sort: true,
      headerAlign: 'center',
      align: 'left',
      formatter: (cell, row, rowIndex) => {
        //{JobHistory?.JOB_INFO?.IS_END_MONTH === 1 ? ",End Of Month" : ""}
        return <>{row.SCHEDULE_DATE}{row.IS_END_MONTH === 1 ? ",End Of Month" : ""}</>;
      },
    },
    
    {
      dataField: "SCHEDULE_TIME",
      text: "Schedule Time",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "START_DATE",
      text: "Start Date",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateFullMonthText(row.START_DATE)}</>;
      },
    },
    {
      dataField: "END_DATE",
      text: "End Date",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateFullMonthText(row.END_DATE)}</>;
      },
    },
    {
      dataField: "ISACTIVE",
      text: "Status",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{row.ISACTIVE === "1" ? "Active" : "Inactive"}</>;
      },
    },
  ]
  return columns;
};
export const getHistoryColumns = (Download) => {
  const columns = [
    // {
    //   dataField: "TALEND_TASK_ID",
    //   text: "Task ID",
    //   sort: true,
    //   headerAlign: 'center',
    //   align: 'center',
    // },
    {
      dataField: "EXEC_NO",
      text: "EXEC ID",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "SCHEDULE_TIME",
      text: "Date",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.SCHEDULE_TIME)}</>;
      },
    },
    {
      dataField: "DATE_TIME_START",
      text: "Start Time",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.DATE_TIME_START)}</>;
      },
    },
    {
      dataField: "DATE_TIME_END",
      text: "End Time",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.DATE_TIME_END)}</>;
      },
    },
    {
      dataField: "STATUS",
      text: "Status",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "ERROR_MESSAGE",
      text: "Error Message",
      sort: true,
      headerAlign: 'center',
    },
    {
      dataField: "EXECUTION_TIME",
      text: "Execution Time(Sec)",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "DID",
      text: "Download",
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            {(row.ISDOWNLOAD === "1") ? (

              <CloudDownloadIcon
                color="action"
                onClick={() => {
                  Download(row.EXEC_NO);
                }}
              />

            ) : row.TEXT_DOWNLOAD}
          </Box>
        );
      },
    },

  ];
  return columns;
};